// extracted by mini-css-extract-plugin
export default {"title":"Title_title__xofsk","titleBrown":"Title_titleBrown__g3JXg","learnmore":"Title_learnmore__RvZm0"};